import React from 'react';
import { CheckCircle2, Clock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { EANRequestDetails } from './EANRequestDetails';

const day = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }) : '');

export const EANSubmittedDialog = ({ result, onClose }) => (
  <Dialog open={!!result} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="ean-submitted-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-emerald-700">
          <CheckCircle2 className="h-5 w-5" /> Request submitted
        </DialogTitle>
      </DialogHeader>
      {result && (
        <div className="space-y-4">
          <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="ean-submitted-timeline">
            <Clock className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
            <div className="text-sm text-amber-900">
              <p>Your EAN will be generated within <b>24–48 working hours</b> (Mon–Fri).</p>
              <p className="mt-0.5">Expected between <b>{day(result.expected_from)}</b> and <b>{day(result.expected_by)}</b>. You'll get an email with the EAN, SKU and barcode once it's generated.</p>
            </div>
          </div>
          <p className="text-xs text-slate-500">Request ID <span className="font-mono font-semibold text-slate-700">{result.request.id.slice(0, 8).toUpperCase()}</span> · a confirmation email has been sent to you and the EAN owners.</p>
          <EANRequestDetails req={result.request} onDownloadBarcode={() => {}} />
          <div className="flex justify-end"><Button onClick={onClose} className="bg-[#2EB4AC] hover:bg-[#25908A]" data-testid="ean-submitted-close">Done</Button></div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
